export var UrlPatternType;
(function (UrlPatternType) {
    UrlPatternType["EXACT"] = "EXACT";
    UrlPatternType["DOMAIN"] = "DOMAIN";
    UrlPatternType["HOSTNAME"] = "HOSTNAME";
    UrlPatternType["HOSTNAME_SUFFIX"] = "HOSTNAME_SUFFIX";
    UrlPatternType["ORIGIN"] = "ORIGIN";
    UrlPatternType["WILDCARD"] = "WILDCARD";
    UrlPatternType["REGEX"] = "REGEX";
    UrlPatternType["COMPOSITE"] = "COMPOSITE";
})(UrlPatternType || (UrlPatternType = {}));
//# sourceMappingURL=types.js.map